import { useState, useEffect, useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useNetworkStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);
  const queryClient = useQueryClient();

  const handleOnline = useCallback(() => {
    setIsOnline(true);
    if (wasOffline || !navigator.onLine) {
      toast.success('Đã kết nối lại', {
        description: 'Dữ liệu đang được cập nhật...',
        duration: 3000,
      });
      queryClient.refetchQueries({ type: 'active' });
    }
    setWasOffline(false);
  }, [wasOffline, queryClient]);

  const handleOffline = useCallback(() => {
    setIsOnline(false);
    setWasOffline(true);
  }, []);

  useEffect(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [handleOnline, handleOffline]);

  return { isOnline, wasOffline };
}
